<script setup lang="ts">
const props = defineProps<{
  slide: any;
  index: number;
}>();

const { slide, index } = toRefs(props);

const sliderColorBackground = computed(() => {
  return slide.value.sliderColorBackground;
});

const buttonOn = computed(() => {
  return slide.value.button_onoff === "on";
});

const button_onoff_offer = computed(() => {
  return slide.value.button_onoff_offer === "on";
});
</script>
<template>
  <div
    class="hero-items relative w-full min-w-full h-[700px]"
    :class="{ 'has-promotional-slide p-4 ': button_onoff_offer }"
    :style="{ backgroundColor: sliderColorBackground }"
  >
    <figure class="hero-overlay h-full flex items-center">
      <template
        v-if="slide.sliderBackgroundDesktop && slide.sliderBackgroundMobile"
      >
        <NuxtImg
          format="webp"
          :src="encodeURI(slide.sliderBackgroundDesktop.url)"
          :loading="index > 0 ? 'lazy' : 'eager'"
          class="img-cover hidden md:block"
          :class="{
            'max-h-[600px] object-contain w-auto m-auto h-auto max-w-full':
            button_onoff_offer,
          }"
          alt=""
          width="1680"
          densities="x1"
        />
        <NuxtImg
          format="webp"
          :src="encodeURI(slide.sliderBackgroundMobile.url)"
          :loading="index > 0 ? 'lazy' : 'eager'"
          class="img-cover md:hidden"
          :class="{
            'max-h-[600px] object-contain w-auto m-auto h-auto max-w-full':
            button_onoff_offer,
          }"
          alt=""
          width="768"
          densities="x1"
        />
      </template>
      <template v-else-if="slide.sliderBackgroundDesktop">
        <NuxtImg
          format="webp"
          :src="encodeURI(slide.sliderBackgroundDesktop.url)"
          :loading="index > 0 ? 'lazy' : 'eager'"
          class="img-cover"
          :class="{
            'max-h-[600px] object-contain w-auto m-auto h-auto max-w-full':
            button_onoff_offer,
          }"
          alt=""
          width="1680"
          densities="x1"
        />
      </template>
      <template v-else-if="slide.sliderBackgroundMobile">
        <NuxtImg
          format="webp"
          :src="encodeURI(slide.sliderBackgroundMobile.url)"
          :loading="index > 0 ? 'lazy' : 'eager'"
          class="img-cover"
          alt=""
          width="768"
          densities="x1"
        />
      </template>
    </figure>
    <div
      class="w-full absolute bottom-[120px] md:top-2/4 md:-translate-y-2/4 text-white"
    >
      <div
        class="container container_sm"
        :class="{ hidden: button_onoff_offer }"
      >
        <div class="overlayTxtSize">
          <h2 class="text-[40px] md:text-5xl lg:text-6xl mb-5 font-bold">
            {{ slide.sliderHeadlineText }}
          </h2>
          <div class="mb-7 md:mb-8" v-html="slide.sliderMainText"></div>
          <SharedButton
            v-if="buttonOn"
            btnType="primary"
            :button="slide.button"
          ></SharedButton>
        </div>
      </div>
    </div>
  </div>
</template>
